export const ApplicationConstant = {
    ApplicationID : 35,
    clientId : 20,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD'
};
